import NextImage from 'next/image'

import { type SanityFrameBuilderImage } from '@frame-builder/data/sanity/queries/types/image'
import {
  getBasicImageLoader,
  getSanityImageUrl,
} from '@frame-builder/lib/image'

interface ItemImageProps {
  image?: SanityFrameBuilderImage
  alt?: string
}

const ItemImage = ({ image, alt }: ItemImageProps) => {
  const imageUrl = getSanityImageUrl(image, {
    width: 80,
    height: 80,
  })

  if (!imageUrl) {
    return null
  }

  return (
    <NextImage
      src={imageUrl}
      width={image?.asset?.metadata?.dimensions?.width}
      height={image?.asset?.metadata?.dimensions?.height}
      alt={alt ?? ''}
      unoptimized
      loader={getBasicImageLoader}
      className="flex-none w-20 h-20 border border-gray-400"
    />
  )
}

export default ItemImage
